<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardChargeTypeList.push"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    search-placeholder="输入课卡套餐名称进行搜索"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="套餐名称" prop="card_charge_type_name"/>
    <el-table-column label="有效天数（天）">
      <template v-slot="{ row }">
        {{ row.expire_days }}
      </template>
    </el-table-column>
    <el-table-column label="停卡时长（天）" width="120">
      <template v-slot="{ row }">
        <span v-if="row.stop_days">{{ row.stop_days | toYuan }}</span>
        <span v-else class="info-color">不可停卡</span>
      </template>
    </el-table-column>
    <el-table-column label="有效次数（次）">
      <template v-slot="{ row }">
        <span v-if="row.is_number_limit">{{ row.expire_number | toYuan }}</span>
        <span v-else class="success-color">无限制</span>
      </template>
    </el-table-column>
    <el-table-column label="价格（元）">
      <template v-slot="{ row }">{{ row.price | toYuan }}</template>
    </el-table-column>
    <el-table-column label="价格描述" prop="price_name"/>
    <el-table-column label="课程类型" prop="card_type_name"/>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.cardChargeTypeEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此套餐吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>套餐 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>套餐名称</span>
              <span>{{ v.card_charge_type_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>有效天数</span>
              <span>{{ v.expire_days }} 天</span>
            </div>
            <div class="list-item-detail">
              <span>停卡时长</span>
              <span v-if="v.stop_days">{{ v.stop_days | toYuan }} 天</span>
              <span v-else class="info-color">不可停卡</span>
            </div>
            <div class="list-item-detail">
              <span>有效次数</span>
              <span v-if="v.is_number_limit">{{ v.expire_number | toYuan }} 次</span>
              <span v-else class="success-color">无限制</span>
            </div>
            <div class="list-item-detail">
              <span>价格</span>
              <span>{{ v.price | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>价格描述</span>
              <span>{{ v.price_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课程类型</span>
              <span>{{ v.card_type_name }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.cardChargeTypeEdit.to(v.id)"/>

              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此套餐吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/card-charge-type';

export default {
  name: RouteConfig.cardChargeTypeList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.warning('缺少套餐 ID，无法删除。');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.warning('缺少套餐信息，无法删除。');

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
